import React, { Component } from 'react';
import './ChatUrlInfo.scss';

interface ChatUrlInfoProps {
  url: string;
  title?: string;
  imageUrl?: string;
  className?: string;
}

interface ChatUrlInfoState {
  imageError: boolean;
}

export class ChatUrlInfo extends Component<ChatUrlInfoProps, ChatUrlInfoState> {
  constructor(props: ChatUrlInfoProps) {
    super(props);
    this.state = {
      imageError: false
    };
  }

  handleError = (): void => {
    this.setState({ imageError: true });
  };

  render(): JSX.Element {
    const { url, title, imageUrl, className } = this.props;
    const { imageError } = this.state;
    const fullClassName = `chat-url-info ${className || ''}`;
    return (
      <a className={fullClassName} href={url} target="_blank" rel="noopener noreferrer">
        <div className="chat-url-info__container">
          {
            (imageUrl && !imageError) &&
            <img
              src={imageUrl}
              className="chat-url-info__image"
              alt=""
              onError={this.handleError} />
          }
          <div className="chat-url-info__info-container">
            <div className="chat-url-info__title">{title ? title : url}</div>
            <div className="chat-url-info__url">{url}</div>
          </div>
        </div>
      </a>
    );
  }
}
